import React from "react";

// third-party
import { Element } from "react-scroll";

// project-imports
import InterviewCategories from "./interview-categories/InterviewCategories";
import SectionTitle from "../sectionTitle/SectionTitle";
import InterviewQuestionHomeStencil from "./stencils/InterviewQuestionHomeStencil";
import { useInterviewContext } from "../../context/interview_context";
import ErrorComponent from "../error-message/ErrorComponent";

const InterviewQuestionHome = () => {
    // Extracting variables from context
    const { interviewCategories, interviewSeries, isLoading, isError, trendingInterviewseries } =
        useInterviewContext();

    // Constant categories
    const categories =
        interviewCategories && interviewCategories?.length
            ? interviewCategories
            : [];
    const series =
        interviewSeries && interviewSeries?.length ? interviewSeries : [];
    const isPublishedSeries = series?.filter((i) => i?.published === true);

    const matchedData = categories?.map((category) => {
        return {
            ...category,
            series: isPublishedSeries?.filter(
                (item) => item?.categoryId === category?.slug,
            ),
        };
    });

    const topLikedSeries = trendingInterviewseries ? trendingInterviewseries?.topLiked : [];
    const topBookMarkedSeries = trendingInterviewseries ? trendingInterviewseries?.topBookmarked : [];
    const topSavedSeries = trendingInterviewseries ? trendingInterviewseries?.topSaved : [];


    if (isLoading) {
        return <InterviewQuestionHomeStencil data={matchedData} />;
    }
    return (
        <div id="popular-interview-topics-to-learn">
            <Element
                name="service"
                className="sercice-area eduvibe-service-five service-wrapper-5 edu-section-gap bg-color-white"
            // id="popular-interview-topics-to-learn"
            >
                <div className="container eduvibe-animated-shape">
                    <div className="row">
                        <div className="col-lg-12">
                            <SectionTitle
                                classes="text-start"
                                slogan="Interview Q&A Categories"
                                title="Popular Interview Topics"
                            />
                        </div>
                    </div>

                    {(!isLoading && isError) ? (
                        <div className="text-center">
                            <ErrorComponent
                                errorCode="500"
                                mainError="No Interview Q&A Categories are available!"
                                subText="Currently we don't have Interview Q&A Categories. Please be back later."
                                buttonText="Back to Home"
                                link="/"
                            />
                        </div>
                    ) : (!isLoading && isError && !matchedData?.length) ? (
                        <div className="text-center">
                            <ErrorComponent
                                errorCode="404"
                                mainError="Failed to get the Interview Q&A Categories right now."
                                subText="Please return to the site's homepage, It looks like nothing was found at this location"
                                buttonText="Back to Home"
                                link="/"
                            />

                        </div>
                    ) : (
                        <InterviewCategories data={matchedData} />
                    )}

                    {/* <div className="shape-dot-wrapper shape-wrapper d-xxl-block d-none">
                        <div className="shape-image shape-image-1">
                            <img src="/images/shapes/shape-19-02.png" alt="Shape Thumb" />
                        </div>
                        <div className="shape-image shape-image-2">
                            <img src="/images/shapes/shape-21.png" alt="Shape Thumb" />
                        </div>
                    </div> */}
                </div>
                <div className="container eduvibe-animated-shape mt--50">
                    <div className="row">
                        {topLikedSeries && topLikedSeries?.length &&
                            <div class="col-lg-4 col-md-6 col-12">
                                <div class="edu-footer-widget explore-widget">
                                    <div className="section-title text-start">
                                        <span className="pre-title fs-17">
                                            Top Liked Q&A Series
                                        </span>
                                    </div>
                                    {/* <h5 class="widget-title">Top Liked Series</h5> */}
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            {topLikedSeries?.map((elm, i) => (
                                                <li className="fs-15">
                                                    <a href={
                                                        process.env.PUBLIC_URL +
                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                    }>
                                                        {elm.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {topBookMarkedSeries && topBookMarkedSeries?.length &&
                            <div class="col-lg-4 col-md-6 col-12">
                                <div class="edu-footer-widget explore-widget">
                                    <div className="section-title text-start">
                                        <span className="pre-title fs-17">
                                            Top Bookmarked Q&A Series
                                        </span>
                                    </div>
                                    {/* <h5 class="widget-title">Top Bookmarked Series</h5> */}
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            {topBookMarkedSeries?.map((elm, i) => (
                                                <li className="fs-15">
                                                    <a href={
                                                        process.env.PUBLIC_URL +
                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                    }>
                                                        {elm.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                        {topSavedSeries && topSavedSeries?.length &&
                            <div class="col-lg-4 col-md-6 col-12">
                                <div class="edu-footer-widget explore-widget">
                                    <div className="section-title text-start">
                                        <span className="pre-title fs-17">
                                            Trending Q&A Series
                                        </span>
                                    </div>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            {topSavedSeries?.map((elm, i) => (
                                                <li className="fs-15">
                                                    <a href={
                                                        process.env.PUBLIC_URL +
                                                        `/interview-questions/${elm?.categoryId}/${elm?.slug}`
                                                    }>
                                                        {elm.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Element>
        </div>
    );
};

export default InterviewQuestionHome;
